export const INTAKE_SKIP_INITIAL_IMPORT_COPY = {
  label: "Do not import existing issues",
  helper: "SuperPlane imports new issues only.",
} as const;
